import { Icon } from "@mdi/react";
import React from "react";

import { mdiContentCopy } from "@mdi/js";
import { arrayOrEmpty } from "utils";

import { EntityKind } from "models/entityKind";

import { useAutomationBroker } from "components/automation/contexts/AutomationBrokerContext";
import { AutomationCommand } from "components/automation/types/automation";
import {
  LoadSavedFilterPayload,
  SettingsProps
} from "components/automation/types/payloads";
import { FilterInfoResult } from "components/automation/types/results";
import { Topics } from "components/automation/types/topics";
import { useProjectListQuery } from "components/project/projects/queries";

import { StyledContainer, StyledCopyButton, StyledLabelValue } from "./shared";

export const LoadProjectSettings: React.FC<SettingsProps<LoadSavedFilterPayload>> = ({
  value,
  onChange
}) => {
  const projectListQuery = useProjectListQuery();
  const broker = useAutomationBroker();
  const loadCurrentProjectAndFilter = async () => {
    const result = await broker.executeCommands([
      {
        id: "get project and filter",
        topic: Topics.GetProjectIdAndSavedFilterInfo,
        delay: 200
      } as AutomationCommand
    ]);
    const item = result.find(
      (r) => (r as FilterInfoResult)?.entityKind === EntityKind.Well
    ) as FilterInfoResult;
    if (!item || !item.projectId) {
      return;
    }

    const project = arrayOrEmpty(projectListQuery.data).find(
      (proj) => proj.projectId === item.projectId
    );

    onChange({
      projectId: item.projectId,
      filterName: item.filterName,
      projectName: project.projectName
    } as LoadSavedFilterPayload);
  };

  return (
    <StyledContainer>
      <StyledCopyButton
        size="large"
        onClick={loadCurrentProjectAndFilter}
        icon={<Icon path={mdiContentCopy} size={1.2} />}>
        Copy Current Project
      </StyledCopyButton>
      <StyledLabelValue>
        <span className="label">Project Name:</span>
        <span className="value">{value?.projectName ?? ""}</span>
      </StyledLabelValue>
    </StyledContainer>
  );
};
